// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact-module--container--JOx2R","companyInfoTitle":"Contact-module--companyInfoTitle--3ePJ2"};